import { motion } from "framer-motion";
import { Volume2 } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export const AdSection = () => (
    <section
        id="ad"
        data-testid="ad-section"
        className="py-20 md:py-32 px-5 sm:px-8 lg:px-12 bg-[#141414]/60 rounded-[2.5rem] mx-3 md:mx-6 my-6 relative overflow-hidden"
    >
        <div
            aria-hidden="true"
            className="pointer-events-none absolute -top-32 -left-24 w-[30rem] h-[30rem] rounded-full bg-[#EAF1F7]/70 blur-3xl"
        />
        <div className="max-w-4xl mx-auto text-center relative">
            <Reveal>
                <Eyebrow className="text-[#D3A0A7]">Savv in motion.</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-4 font-serif-ed text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-[#F1F1EF]">
                    Press play —{" "}
                    <span className="italic text-[#D3A0A7]">
                        this is the vibe.
                    </span>
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <motion.div
                    whileHover={{ scale: 1.01 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="relative mt-12 rounded-[2rem] overflow-hidden border-4 border-[#F1F1EF] shadow-[0_40px_80px_-25px_rgba(140,138,134,0.45)] bg-[#0C0C0C]"
                >
                    <video
                        data-testid="ad-video"
                        src="/videos/savv-ad-web.mp4"
                        poster="/videos/savv-ad-poster.jpg"
                        autoPlay
                        muted
                        loop
                        playsInline
                        controls
                        preload="metadata"
                        className="w-full h-auto block"
                    />
                </motion.div>
            </Reveal>
            <Reveal delay={0.3}>
                <p className="mt-6 inline-flex items-center gap-2 font-hand text-2xl text-[#D3A0A7] rotate-[-1.5deg]">
                    <Volume2 size={18} />
                    tap the video for sound ♡
                </p>
            </Reveal>
        </div>
    </section>
);
